// localStorage for small per-viewer conveniences. It can be missing or throw (private windows, blocked
// site data), so every access is guarded and callers must work without it.

export const readStored = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const writeStored = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    // not persisted: the app still works
  }
};
